import { Link, LinkProps, Text, TextProps } from '@cmpsr/components';
import React from 'react';
import ReactMarkdown, { ExtraProps, Options } from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * Our standard markdown component for rendering plain text
 * Uses https://github.com/remarkjs/react-markdown
 *
 * If you need to customize how sub elements are rendered, you may want to create
 * a separate component (e.g. for questions on the risk assessment)
 */
export default function Markdown(props: Exclude<Options, 'components'>): React.ReactElement {
  const { children, ...rest } = props;
  const transformedChildren = typeof children === 'string' ? children.replace(/\\n/g, '\n') : children;

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        p(props: TextProps & ExtraProps) {
          const { node, ...rest } = props;
          return <Text py="spacer-3" variant="text-body-regular" {...rest} />;
        },
        a(props: LinkProps & ExtraProps) {
          const { node, ...rest } = props;
          return (
            <Link
              target="_blank"
              display="inline"
              textDecoration="underline"
              color="text-link-secondary-default"
              {...rest}
            />
          );
        },
        br: 'br',
      }}
      {...rest}
      children={transformedChildren}
    />
  );
}
